module.exports = __webpack_public_path__ + "img/bg_day.c7923ea5.jpg";